module.exports = __webpack_public_path__ + "static/media/lightningGamesPlayed_1000_5000.5a1577e3.png";